import script from "./StackedCards.vue?vue&type=script&setup=true&lang=js"
export * from "./StackedCards.vue?vue&type=script&setup=true&lang=js"

import "./StackedCards.vue?vue&type=style&index=0&id=ac072180&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac072180"]])

export default __exports__